import { baseFetchToken } from './BaseSaga'
import LocationAction from '../Redux/LocationRedux'
import { getToken } from '../Services/GetToken'

export function * getProvince (api, action) {
  yield baseFetchToken(
    api.getProvince,
    action.data,
    getToken,
    LocationAction.getProvinceSuccess,
    LocationAction.getProvinceFailure
  )
}

export function * getCities (api, action) {
  yield baseFetchToken(
    api.getCities,
    action.data,
    getToken,
    LocationAction.getCitySuccess,
    LocationAction.getCityFailure
  )
}

export function * getDistricts (api, action) {
  yield baseFetchToken(
    api.getDistricts,
    action.data,
    getToken,
    LocationAction.getDistrictSuccess,
    LocationAction.getDistrictFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/LocationSagas.js